import React from "react";
import { connect } from "react-redux";

import { Template } from "./templates";

function TransferCustom({
  template,
  ...conf
}) {
  if (!template) {
    return 'Transfer needs a template';
  }
  return <Template template={template} conf={conf} />
}
const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(TransferCustom);